import { render, staticRenderFns } from "./inpatient.vue?vue&type=template&id=08f56afa&scoped=true"
import script from "./inpatient.vue?vue&type=script&lang=js"
export * from "./inpatient.vue?vue&type=script&lang=js"
import style0 from "./inpatient.vue?vue&type=style&index=0&id=08f56afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f56afa",
  null
  
)

export default component.exports